import Inputs from './Inputs'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose } from 'recompose'
import { withRouter } from 'react-router-dom'
import {
  changeSelectedDeliveryDay,
  changeSelectedDeliveryTime,
  setZipcode,
  changeSelectedAddress,
  clearOrder
} from '../../../store/actions/order'
import {
  getTimeslots,
  getUpcomingDays,
  getMenu
} from '../../../store/effects/public'
import * as authSelectors from '../../../selectors/auth'
import * as publicSelectors from '../../../selectors/public'
import * as orderSelectors from '../../../selectors/order'
import * as userSelectors from '../../../selectors/user'

const mapStateToProps = state => ({
  deliveryDays: publicSelectors.getDeliveryDays(state),
  deliveryTimes: publicSelectors.getDeliveryTimes(state),
  selectedDeliveryTime: orderSelectors.getSelectedDeliveryTime(state),
  selectedDeliveryDay: orderSelectors.getSelectedDeliveryDay(state),
  selectedZipcode: orderSelectors.getZipcode(state),
  userIsLoggedIn: authSelectors.userIsLoggedIn(state),
  authChecked: authSelectors.authChecked(state),
  addresses: userSelectors.getAddresses(state),
  selectedAddress: orderSelectors.getSelectedAddress(state),
  mealCount: orderSelectors.getOrderMealCount(state)
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      changeSelectedDeliveryDay,
      changeSelectedDeliveryTime,
      setZipcode,
      getUpcomingDays,
      getTimeslots,
      getMenu,
      changeSelectedAddress,
      clearOrder
    },
    dispatch
  )

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(Inputs)



// WEBPACK FOOTER //
// ./src/modules/Menu/Inputs/index.js